/* This is the Climate Change Component N.4  */

<template>
  <v-container>
    <div>
      <strong><span v-html="title"></span></strong>
    </div>
    <div>
      <table border="1px;" cellspacing="0px;">
        <tbody>
          <tr>
            <td
              style="width: 220px; text-align: center; vertical-align: middle"
              rowspan="2"
            >
              គ្រោះធម្មជាតិ
            </td>
            <td style="width: 160px; text-align: center" colspan="2">
              ចំនួនបន្ទប់រៀន
            </td>
            <td
              style="width: 160px; height: 25px; text-align: center"
              colspan="2"
            >
              ចំនូនអាគារសិក្សា
            </td>
            <td
              style="width: 160px; height: 25px; text-align: center"
              colspan="2"
            >
              ចំនួនបង្គន់អនាម័យ
            </td>
            <td
              style="width: 160px; height: 25px; text-align: center"
              colspan="2"
            >
              ចំនួនកន្លែងលាងដៃ
            </td>
          </tr>
          <tr style="height: 50px; text-align: center">
            <td style="width: 50px">ខូចខាត<br />(នៅប្រើកើត)</td>
            <td style="width: 50px">ខូចខាតទំាងស្រុង<br />(បើ្រលែងកើត)</td>
            <td style="width: 50px">ខូចខាត<br />(នៅប្រើកើត)</td>
            <td style="width: 50px">ខូចខាតទំាងស្រុង<br />(បើ្រលែងកើត)</td>
            <td style="width: 50px">ខូចខាត<br />(នៅប្រើកើត)</td>
            <td style="width: 50px">ខូចខាតទំាងស្រុង<br />(បើ្រលែងកើត)</td>
            <td style="width: 50px">ខូចខាត<br />(នៅប្រើកើត)</td>
            <td style="width: 50px">ខូចខាតទំាងស្រុង<br />(បើ្រលែងកើត)</td>
          </tr>
          <tr
            v-for="(value, row) in disasterLabel.length"
            :key="row"
            style="height: 25px; text-align: left"
          >
            <td style="width: 200px; height: 25px">{{ disasterLabel[row] }}</td>
            <td style="width: 100px; height: 25px">
              <numberinput
                v-model="data[row].d[0]"
                style="width: 100px; text-align: center"
              />
            </td>
            <td style="width: 100px; height: 25px">
              <numberinput
                v-model="data[row].d[1]"
                style="width: 100px; text-align: center"
              />
            </td>
            <td style="width: 100px; height: 25px">
              <numberinput
                v-model="data[row].d[2]"
                style="width: 100px; text-align: center"
              />
            </td>
            <td style="width: 100px; height: 25px">
              <numberinput
                v-model="data[row].d[3]"
                style="width: 100px; text-align: center"
              />
            </td>
            <td style="width: 100px; height: 25px">
              <numberinput
                v-model="data[row].d[4]"
                style="width: 100px; text-align: center"
              />
            </td>
            <td style="width: 100px; height: 25px">
              <numberinput
                v-model="data[row].d[5]"
                style="width: 100px; text-align: center"
              />
            </td>
            <td style="width: 100px; height: 25px">
              <numberinput
                v-model="data[row].d[6]"
                style="width: 100px; text-align: center"
              />
            </td>
            <td style="width: 100px; height: 25px">
              <numberinput
                v-model="data[row].d[7]"
                style="width: 100px; text-align: center"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { disasterLabel } from "@/utils/ascf/climateVariables.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      disasterLabel: disasterLabel,
    };
  },
};
</script>
<style scoped>
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
}
</style>